import React from "react";
import socialsImg from "/fallbacks/socials.png";
import parse from "html-react-parser";

const SocialMediaBanner = () => {
  const heroContent = window.post_template?.checkout_v4_product_hero;
  const avatarsImage = heroContent?.checkout_v4_product_hero_socialbanner_avatarsgallery
    ? heroContent?.checkout_v4_product_hero_socialbanner_avatarsgallery
    : socialsImg;
  const customersText = heroContent?.tr_checkout_v4_product_hero_customers_label;
  const ratingsText = heroContent?.tr_checkout_v4_product_hero_rating_label;
  const borderColor = heroContent?.checkout_v4_product_hero_socialsBorderColor;
  const backgroundColor = heroContent?.checkout_v4_product_hero_socialsBackground;
  const textColor = heroContent?.checkout_v4_product_hero_socialsTextColor;

  return (
    <div className="productHero__socialMediaBanner">
      <div
        className="productHero__socialMediaBanner__avatars"
        style={{ borderColor: borderColor, background: backgroundColor }}
      >
        <div className="productHero__socialMediaBanner__avatars__cont">
          <img
            src={avatarsImage}
            className="productHero__socialMediaBanner__avatars__item mon-img-96-w"
            alt={general_settings.brand_name}
          />
        </div>
        <div>
          <span className="productHero__socialMediaBanner__text" style={{ color: textColor }}>
            {customersText && parse(customersText)}
          </span>
          <span className="productHero__socialMediaBanner__text" style={{ color: textColor }}>
            {ratingsText && parse(ratingsText)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SocialMediaBanner;
